import React from 'react';
import { useLocation } from 'react-router';
import { useEvent } from '../../data/hooks/eventHooks';
import { useEventParticipant } from '../../data/hooks/participant/useEventParticipant';
import { useMyUserId } from '../../data/hooks/sessionHooks';
import addURLParameters from '../../misc/addURLParameters';
import resolvePath from '../../misc/resolvePath';
import WaitWhileBusy from '../WaitWhileBusy';
import UserProfile from './UserProfile';

const EventParticipantProfile = (props) => {
    const { eventId, userId, participantId, questionId, path, itemId } = props,
        event = useEvent(eventId),
        myUserId = useMyUserId(),
        isMe = userId == myUserId,
        user = useEventParticipant(
            eventId,
            { userId, participantId },
            {
                questionId,
                directoryItemId: path ? path.split('/').pop() : null,
                sessionId: itemId,
            }
        ),
        canBeInvited = !event.settings.disable_meetings && event.joined && !isMe && user.user_id,
        location = useLocation(),
        inviteURL = addURLParameters(resolvePath(location.pathname, 'invite'), { participants: participantId, users: userId });

    return <UserProfile event={event} user={user} returnURL="../.." canBeInvited={canBeInvited} inviteURL={inviteURL} isMe={isMe} />;
};

export default (props) => (
    <WaitWhileBusy>
        <EventParticipantProfile {...props.match.params} />
    </WaitWhileBusy>
);
